import { useEffect, useState } from 'react';
import { Checkbox, Flex, Modal, Typography } from 'antd';

const { Text } = Typography;

type InboundMarkShipmentCompleteModalProps = {
  open: boolean;
  onClose: () => void;
  unusedPalletCount: number;
  loading?: boolean;
  onConfirm: (discardUnusedPallets: boolean) => void;
};

export function InboundMarkShipmentCompleteModal({
  open,
  onClose,
  unusedPalletCount,
  loading = false,
  onConfirm,
}: InboundMarkShipmentCompleteModalProps) {
  const [discardUnusedPallets, setDiscardUnusedPallets] = useState(false);

  useEffect(() => {
    if (!open) {
      setDiscardUnusedPallets(false);
    }
  }, [open]);

  const hasUnusedPallets = unusedPalletCount > 0;

  return (
    <Modal
      title="Mark shipment as completed"
      open={open}
      centered
      onCancel={onClose}
      okText="Confirm"
      cancelText="Cancel"
      confirmLoading={loading}
      onOk={() => onConfirm(hasUnusedPallets ? discardUnusedPallets : false)}
      destroyOnClose
    >
      <Flex vertical gap={16}>
        <Text>
          Intake for this shipment will be marked complete. This action cannot be undone.
        </Text>
        {hasUnusedPallets ? (
          <Flex vertical gap={4}>
            <Checkbox
              checked={discardUnusedPallets}
              onChange={e => setDiscardUnusedPallets(e.target.checked)}
            >
              Discard unused pallets
            </Checkbox>
            <Text type="secondary" style={{ fontSize: 13, marginLeft: 24 }}>
              {unusedPalletCount} empty pallet
              {unusedPalletCount === 1 ? '' : 's'} on this shipment
            </Text>
          </Flex>
        ) : null}
      </Flex>
    </Modal>
  );
}
